import { SWReactIcons } from "@similarweb/icons";
import { InsightBanner } from "@similarweb/ui-components";
import {
    StyledInsightBannerWrapper,
    StyledTopicBlock,
    StyledTopicHeaderContainer,
    StyledTopicHeaderTitle,
} from "./styles";
import { translate } from "app/filters/i18nFilter";
import IntentTopicTable from "../IntentTopicTable/IntentTopicTable";
import IntentTooltipContent from "app/pages/sales-intelligence/common-components/tooltip/IntentTooltipContent/IntentTooltipContent";
import intentTrackingService from "app/pages/sales-intelligence/services/tracking/intent/trackingService";
import InsightTooltip from "app/pages/sales-intelligence/common-components/tooltip/InsightTooltip/InsightTooltip";

const AddTopicView = () => {
    return (
        <StyledTopicBlock>
            <StyledTopicHeaderContainer>
                <StyledTopicHeaderTitle>{translate("si.intent.management.add-topic.header")}</StyledTopicHeaderTitle>
                <StyledInsightBannerWrapper>
                    <InsightTooltip content={<IntentTooltipContent />}>
                        <InsightBanner
                            title={translate("si.intent.management.add-topic.topic-tips")}
                            onMouseEnter={() => void intentTrackingService.trackOnHoverTopicTips()}
                            icon={
                                <SWReactIcons
                                    size="xs"
                                    iconName="light-bulb"
                                />
                            }
                        />
                    </InsightTooltip>
                </StyledInsightBannerWrapper>
            </StyledTopicHeaderContainer>
            <IntentTopicTable />
        </StyledTopicBlock>
    );
};

export default AddTopicView;
